import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IRtpSendTransaction } from '../../interfaces/send-payment/rtp-send-payment.interface';

export abstract class AbstractRtpSendPaymentService {
  abstract sendTransaction(transaction: IRtpSendTransaction): Promise<IWebMessage | undefined>;
}
